import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { LoaderService, LoaderState } from 'src/app/Services/LoaderService/loader.service';

@Component({
  standalone: false,
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderComponent {
  readonly loaderState$: Observable<LoaderState>;

  constructor(private loaderService: LoaderService) {
    this.loaderState$ = this.loaderService.loaderState$;
  }
}
